import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import { CatalogueEntry } from "../CatalogueEntry";
import DataCache from "../../../Services/DataCache";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import Bank from "../../../Models/Catalogue/Generic/Bank";
import { Catalogue } from "@singularsystems/neo-react-services";

export default class BankCatalogueEntry extends CatalogueEntry<Bank> {

    constructor() {
        super("Banks", Bank);
    }

    public get editRole() {
        return CatalogueRoles.Banks.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.banks;
    }
    
    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return apiClient.saveBanks;
    }
    
    public renderRow(item: Bank, meta: Model.TransformMetaType<Bank>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.bankName} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}